import { getCommercialLicenseMappingsState } from './commercial-license-mappings.selectors'
import ListTrait from 'src/app/traits/list.trait'
import {
  SetDefaultData,
  UpdateField,
  FetchCommercialLicenseMappingsRequest,
  DeleteCommercialLicenseMappingRequest,
  OrderCommercialLicenseMappingRequest,
} from './commercial-license-mappings.actions'
import { Router, ActivatedRoute } from '@angular/router'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnChanges, OnDestroy } from '@angular/core'
import { Subscription } from 'rxjs'
import { Map } from 'immutable'

@Component({
  selector: 'app-commercial-license-mappings',
  templateUrl: './commercial-license-mappings.component.html',
  styleUrls: ['./commercial-license-mappings.component.css'],
})
export class CommercialLicenseMappingsComponent
  extends ListTrait
  implements OnInit, OnDestroy
{
  private state$: Subscription
  private shouldReload: boolean = false
  public isLoading: boolean = false
  public columns: object[] = [
    {
      prop: 'propertyType',
      name: 'PROPERTY_TYPE',
    },
    {
      prop: 'rate',
      name: 'RATE',
    },
    {
      prop: 'template',
      name: 'TEMPLATE',
      render: (column: Map<string, any>) => column && column.get('name'),
    },
    {
      width: '250px',
      name: '',
      template: 'actionsColumn',
    },
  ]

  constructor(
    private store: Store<any>,
    public router: Router,
    private route: ActivatedRoute,
  ) {
    super(router)
  }

  ngOnInit() {
    this.store.dispatch<any>(new SetDefaultData('list'))
    this.state$ = this.store
      .pipe(select(getCommercialLicenseMappingsState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')

        if (
          this.shouldReload !== state.get('shouldReload') &&
          state.get('shouldReload')
        ) {
          this.shouldReload = state.get('shouldReload')
          this.store.dispatch<any>(new FetchCommercialLicenseMappingsRequest())
        }
      })
    this.store.dispatch<any>(new FetchCommercialLicenseMappingsRequest())
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
  }

  public deleteCommercialLicenseMapping(id: number) {
    this.store.dispatch(new DeleteCommercialLicenseMappingRequest(id))
  }

  public order(id: number, direction: string) {
    this.store.dispatch(new OrderCommercialLicenseMappingRequest(id, direction))
  }
}
